import { render, staticRenderFns } from "./AddReceivedItem.vue?vue&type=template&id=63b9df5f&"
import script from "./AddReceivedItem.vue?vue&type=script&lang=js&"
export * from "./AddReceivedItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports